import { render, staticRenderFns } from "./InfoDetailsVS.vue?vue&type=template&id=c6748508&scoped=true"
import script from "./InfoDetailsVS.vue?vue&type=script&lang=js"
export * from "./InfoDetailsVS.vue?vue&type=script&lang=js"
import style0 from "./InfoDetailsVS.vue?vue&type=style&index=0&id=c6748508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6748508",
  null
  
)

export default component.exports